const en = {
  language: "Language",
  loading: "Loading",
  app: {
    title: "TruBuy",
    description: "A procurement system for efficient purchasing",
  },
  welcome: {
    title: "Welcome to truBuy",
    description: "A procurement system for efficient purchasing",
  },
  header: {
    logout: "Logout",
  },
  theme: {
    switch: "Switch Theme",
    dark: "Dark",
    light: "Light",
  },
  languageSwitcher: {
    switch: "Switch Language",
    en: "English",
    am: "Amharic",
  },
  dashboard: {
    title: "Procurement Dashboard",
    welcome: "Welcome back!",
    summary: "Track your procurement workflow from planning to payment",
    procurementFlow: "Procurement Flow",
    navigateFlow: "Navigate through your procurement pipeline",
    quickActions: "Quick Actions",
    recentItems: "Recent Items",
    viewAll: "View All",
    noItems: "No recent items",
    createNew: "Create New",
  },
  procurementPlans: {
    title: "Procurement Plans",
    create: "Create Plan",
    edit: "Edit Plan",
    show: "View Plan",
    list: "All Plans",
  },
  users: {
    title: "Users",
    create: "Create User",
    edit: "Edit User",
    show: "View User",
    list: "All Users",
  },
  suppliers: {
    title: "Suppliers",
    create: "Create Supplier",
    edit: "Edit Supplier",
    show: "View Supplier",
    list: "All Suppliers",
  },
  products: {
    title: "Products",
    create: "Create Product",
    edit: "Edit Product",
    show: "View Product",
    list: "All Products",
  },
  requisitions: {
    title: "Requisitions",
    create: "Create Requisition",
    edit: "Edit Requisition",
    show: "View Requisition",
    list: "All Requisitions",
  },
  purchaseOrders: {
    title: "Purchase Orders",
    create: "Create Order",
    edit: "Edit Order",
    show: "View Order",
    list: "All Orders",
  },
  purchaseRequests: {
    title: "Purchase Requests",
    create: "New Purchase Request",
    edit: "Edit Purchase Request",
    show: "View Purchase Request",
    list: "All Purchase Requests",
  },
  sourcings: {
    title: "Sourcing",
    create: "New Sourcing",
    edit: "Edit Sourcing",
    show: "View Sourcing",
    list: "All Sourcing",
  },
  receivings: {
    title: "Receivings",
    create: "Create Receiving",
    edit: "Edit Receiving",
    show: "View Receiving",
    list: "All Receivings",
  },
  paymentRequests: {
    title: "Payment Requests",
    create: "New Payment Request",
    edit: "Edit Payment Request",
    show: "View Payment Request",
    list: "All Payment Requests",
  },
  documentTitle: {
    default: "TruBuy",
    suffix: " | TruBuy"
  },
  // Menu Group Translations
  resources: {
    procurement: {
      title: "Procurement",
    },
    execution: {
      title: "Execution",
    },
    templates: {
      title: "Templates",
    },
    finance: {
      title: "Finance",
    },
    configuration: {
      title: "Configuration",
    },
  },
  organization: {
    title: "Organization",
    create: "Create Organization",
    edit: "Edit Organization",
    show: "View Organization",
    list: "All Organizations",
  },
};

export default en;
